(function () {
  'use strict';

  var WACHT = 220;
  var MINIMUM = 2;
  var AANTAL = 6;
  var AUTOS = 3;

  var tag = document.currentScript;
  var T = (tag && tag.dataset) || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ZAKELIJK = document.body.classList.contains('vt-zakelijk');
  var volgnummer = 0;

  var Index = (function () {
    var SLEUTEL = 'vt-zoekindex:' + ROOT + (document.documentElement.lang || '');
    var lijst = null;
    var belofte = null;

    function bereid(d) {
      var uit = [];
      (d.b || []).forEach(function (r) { uit.push(item(r, true)); });
      (d.m || []).forEach(function (r) { uit.push(item(r, false)); });
      return uit;
    }
    function item(r, merk) {
      var w = norm(r[0]).split(' ');
      return { naam: r[0], url: r[1], merk: merk, woorden: w, aaneen: w.join('') };
    }

    function laad() {
      if (lijst) return Promise.resolve(lijst);
      try {
        var bewaard = sessionStorage.getItem(SLEUTEL);
        if (bewaard) { lijst = bereid(JSON.parse(bewaard)); return Promise.resolve(lijst); }
      } catch (e) {  }

      if (!belofte) {
        belofte = fetch(ROOT + '?sections=vt-zoek-index', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('zoeklijst')); })
          .then(function (d) {
            var tmp = document.createElement('div');
            tmp.innerHTML = d['vt-zoek-index'] || '';
            var sc = tmp.querySelector('script[data-vt-zoek-index]');
            if (!sc) throw new Error('zoeklijst leeg');
            var data = JSON.parse(sc.textContent);
            try { sessionStorage.setItem(SLEUTEL, JSON.stringify(data)); } catch (e) {  }
            lijst = bereid(data);
            return lijst;
          })
          .catch(function (e) { belofte = null; throw e; });
      }
      return belofte;
    }

    return { laad: laad, nu: function () { return lijst; } };
  })();

  function norm(s) {
    return String(s == null ? '' : s).normalize('NFD').replace(/[̀-ͯ]/g, '')
      .toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function past(item, w) {
    if (item.woorden.indexOf(w) !== -1) return 2;
    for (var i = 0; i < item.woorden.length; i++) {
      if (item.woorden[i].indexOf(w) === 0) return 1;
    }
    if (w.length >= 3 && item.aaneen.indexOf(w) !== -1) return 1;
    return 0;
  }

  var VAN = { vw: 'volkswagen' };
  function vind(term, lijst) {
    if (!lijst) return [];
    var woorden = norm(term).split(' ').filter(Boolean).map(function (w) { return VAN[w] || w; });
    var echt = woorden.filter(function (w) {
      return lijst.some(function (it) { return past(it, w) > 0; });
    });
    var anker = echt.some(function (w) {
      return /[a-z]/.test(w) && lijst.some(function (it) {
        var p = past(it, w); return p === 2 || (p === 1 && w.length >= 3);
      });
    });
    if (!echt.length || !anker) return [];

    var uit = [];
    lijst.forEach(function (it) {
      var score = 0;
      for (var i = 0; i < echt.length; i++) {
        var p = past(it, echt[i]);
        if (!p) return;
        score += p;
      }
      uit.push({ it: it, score: score });
    });
    uit.sort(function (a, b) {
      return (b.score - a.score) || (b.it.merk - a.it.merk) || (a.it.naam.length - b.it.naam.length);
    });
    return uit.slice(0, AUTOS).map(function (x) { return x.it; });
  }

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  document.querySelectorAll('form[action*="/search"]').forEach(bouw);

  function bouw(form) {
    var veld = form.querySelector('input[type="search"], input[name="q"]');
    if (!veld) return;
    var typeVeld = form.querySelector('input[name="type"]');
    var metAutos = !(typeVeld && typeVeld.value === 'article');

    var doos = document.createElement('div');
    doos.className = 'vt-sug';
    doos.hidden = true;
    doos.setAttribute('role', 'listbox');

    form.style.position = form.style.position || 'relative';
    form.appendChild(doos);

    var timer = null;
    var laatste = '';
    var bezig = null;
    var producten = [];
    var gevraagd = '';

    volgnummer += 1;
    doos.id = 'vt-sug-' + volgnummer;
    doos.setAttribute('aria-label', veld.getAttribute('aria-label') || T.producten || '');
    veld.setAttribute('autocomplete', 'off');
    veld.setAttribute('role', 'combobox');
    veld.setAttribute('aria-autocomplete', 'list');
    veld.setAttribute('aria-controls', doos.id);
    veld.setAttribute('aria-expanded', 'false');

    if (metAutos) {
      veld.addEventListener('focus', function () {
        Index.laad().then(function () {
          var term = veld.value.trim();
          if (term.length >= MINIMUM && term === gevraagd) toon(term);
        }).catch(function () {  });
      }, { once: true });
    }

    veld.addEventListener('input', function () {
      clearTimeout(timer);
      var term = veld.value.trim();
      if (term.length < MINIMUM) { sluit(); return; }
      timer = setTimeout(function () { zoek(term); }, WACHT);
    });

    veld.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { sluit(); veld.blur(); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var items = [].slice.call(doos.querySelectorAll('a'));
      if (!items.length) return;
      e.preventDefault();
      var nu = items.indexOf(document.activeElement);
      var volgende = e.key === 'ArrowDown' ? nu + 1 : nu - 1;
      if (volgende < 0) { veld.focus(); return; }
      if (volgende >= items.length) volgende = items.length - 1;
      items[volgende].focus();
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) sluit();
    });

    function sluit() {
      laatste = '';
      doos.hidden = true;
      doos.innerHTML = '';
      veld.setAttribute('aria-expanded', 'false');
    }

    function zoek(term) {
      if (term === laatste) return;
      laatste = term;

      if (bezig) bezig.abort();
      bezig = new AbortController();

      var url = ROOT + 'search/suggest.json' +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=product' +
        '&resources[limit]=' + AANTAL +
        '&resources[options][unavailable_products]=last';

      fetch(url, { signal: bezig.signal })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          producten = (d.resources && d.resources.results &&
                       d.resources.results.products) || [];
          gevraagd = term;
          toon(term);
        })
        .catch(function (e) {
          if (e.name === 'AbortError') return;
          console.warn('[Voltrade] zoeksuggesties mislukt', e);
          producten = [];
          gevraagd = term;
          toon(term);
        });
    }

    function toon(term) {
      var autos = metAutos ? vind(term, Index.nu()) : [];
      if (!producten.length && !autos.length) { sluit(); return; }

      var html = '';
      if (autos.length) {
        html += '<div class="vt-sug__kop" aria-hidden="true">' + esc(T.autos) + '</div>' +
          '<div role="group" aria-label="' + esc(T.autos) + '">' +
          autos.map(function (a) {
            return '<a class="vt-sug__auto" href="' + esc(a.url) + '" role="option">' +
              '<span class="vt-sug__t">' + esc(a.naam) + '</span>' +
              '<span class="vt-sug__s">' + esc(a.merk ? T.merk : T.past) + '</span></a>';
          }).join('') + '</div>';
        if (producten.length) {
          html += '<div class="vt-sug__kop" aria-hidden="true">' + esc(T.producten) + '</div>';
        }
      }
      html += producten.map(function (p) {
        var foto = p.featured_image && p.featured_image.url
          ? '<img src="' + p.featured_image.url + '&width=120" alt="" ' +
            'width="48" height="48" loading="lazy">'
          : '<span class="vt-sug__leeg"></span>';
        return '<a href="' + p.url + '" role="option">' +
          '<span class="vt-sug__m">' + foto + '</span>' +
          '<span class="vt-sug__t">' + esc(p.title) + '</span>' +
          (ZAKELIJK ? '' : '<span class="vt-sug__p">' + (p.price ? geld(p.price) : '') + '</span>') +
          '</a>';
      }).join('');
      if (producten.length) {
        html += '<a class="vt-sug__alles" href="' + ROOT +
          'search?type=product&q=' + encodeURIComponent(term) + '">' + esc(T.alles) + '</a>';
      }
      doos.innerHTML = html;
      doos.hidden = false;
      veld.setAttribute('aria-expanded', 'true');
    }

    function geld(p) {
      if (typeof p === 'number') return window.vtGeld(p);
      if (typeof p === 'string' && /^\d+(\.\d+)?$/.test(p.trim())) {
        return window.vtGeld(Math.round(parseFloat(p) * 100));
      }
      return p;
    }
  }

  var vak = document.querySelector('[data-vt-zoek-autos]');
  if (vak && vak.dataset.term) {
    Index.laad().then(function (lijst) {
      var autos = vind(vak.dataset.term, lijst);
      if (!autos.length) return;
      var ul = vak.querySelector('ul');
      ul.innerHTML = autos.map(function (a) {
        return '<li><a href="' + esc(a.url) + '">' + esc(a.naam) + '</a></li>';
      }).join('');
      vak.hidden = false;
    }).catch(function () {  });
  }
})();
